module.exports = __webpack_public_path__ + "static/media/Jolene Carey Headshot_1727346680573.09d40f9a.jpeg";